export enum HrModuleType {
    PAYROLL = 'payroll',
    PERSONNEL = 'personnel',
    GENERAL = 'general',
    PERFORMANCE = 'performance',
    RECRUITMENT = 'recruitment',
    APPLICATION = 'application',
    EDUCATION = 'education',
}
